export default {
  fetch: {
    USER_INFORMATION: 'FETCH_USER_INFORMATION',
    ACTIVITY_STATUS: 'FETCH_ACTIVITY_STATUS',
    LATEST_DONATE: 'FETCH_LATEST_DONATE',
    USER_OVERVIEW: 'FETCH_USER_OVERVIEW',
    USER_SUMMRAY: 'FETCH_USER_SUMMRAY',
    GROUP_LEADERBOARD: 'FETCH_GROUP_LEADERBOARD',
    GROUP_LIST: 'FETCH_GROUP_LIST',
    PERSON_LEADERBOARD: 'FETCH_PERSON_LEADERBOARD',
    SHARED_CONTENTS: 'FETCH_SHARED_CONTENTS'
  },
  post: {
    JOININ_ACTIVITY: 'POST_JOININ_ACTIVITY',
    DONATE_COURSE: 'POST_DONATE_COURSE',
    JOININ_GROUP: 'POST_JOININ_GROUP',
    SHARED_CONTENTS: 'POST_SHARED_CONTENTS'
  }
}



// WEBPACK FOOTER //
// ./src/store/action-types.js